import { HashRouter, Routes, Route } from 'react-router-dom';
import { Home } from './Home';
import { About } from './About';
import { Credits } from './Credits';
import { Business } from './Business';
import { Support } from './Support';

import { STATS } from './CONSTANTS'

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route exact path="/" element={
          <Home
            youtubeSubCount={STATS.youtubeSubCount}
            twitchFollowCount={STATS.twitchFollowcount}
          >
          </Home>} />
        <Route exact path="/about" element={<About />} />
        <Route exact path="/credits" element={<Credits />} />
        <Route exact path="/business" element={<Business />} />
        <Route exact path="/support" element={<Support />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
